
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 10H2.2l4.4-4.5c.2-.2.2-.5 0-.7-.3-.2-.6-.2-.8 0L.6 10.1c-.2.2-.2.5 0 .7l5.2 5.3c.1.1.2.2.4.2.1 0 .3 0 .3-.1.2-.2.2-.5 0-.7L2.2 11h16.3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"}})])
          )
        }
      }
    